<template>
  <div class="shoppping-guide-detail">
    <div class="banner banner-2501">
      <!-- <img class="img-responsive" src="./images/DSC_0632.png" alt /> -->
      <Banner loc="5-2" :baseBtn="false"/>
      <!-- <div class="tx-wrap">
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <button class="add-cart-btn" @click="goProductDetail">查看商品</button>
      </div> -->
    </div>
    <div class="breadcrumbs c-layout">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.guide') }}</span>
      <!-- <span class="p-16">/</span>
      <span>衣物與日常</span>
      <span class="p-16">/</span>
      <span>關於XX</span> -->
      <span class="p-16">/</span>
      <span class="o-color">{{data.name}}</span>
    </div>
    <div class="content c-layout detail-content-dc">
      <div class="date">{{moment(data.createTime).format("MMM DD ddd YYYY")}}</div>
      <div class="title">{{data.name}}</div>
      <div class="desc" v-html="data.content"></div>
    </div>
    <button class="go-back-btn" @click="$router.go(-1)">{{ $t('btns.back') }}</button>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import { getGuideDetail } from "@/api";
import moment from "moment";

export default {
  data() {
    return {
      data: "",
    };
  },
  mounted() {
    let { id } = this.$route.query;
    getGuideDetail({ id }).then((res) => {
      this.data = res.share;
    });
  },
  methods: {
    moment,
    goProductDetail() {
      this.$router.push({ name: "goodsDetail", query: { goods_id: this.data.product_no } });
    }
  },
  components: {
    Banner
  },
};
</script>

<style scoped lang='less'>
.shoppping-guide-detail {
  .content {
    margin-bottom: 100px;
  }
  .banner {
    width: 100%;
    // height: 675px;
  }
  .go-back-btn {
    cursor: pointer;
    display: block;
    margin: 45px auto 45px;
    width: 125px;
    height: 40px;
    background: var(---unnamed-color-ec4f00);
    box-shadow: 0px 3px 6px #00000029;
    color: var(--unnamed-color-ffffff);
    font-size: 16px;
    font-weight: lighter;
  }
  @media (max-width: 992px) {
    .banner {
      // height: 330px;
    }
    .breadcrumbs {
      display: none;
    }
    .content {
      padding: 20px;
      .date {
        text-align: left;
        font-size: 1rem;
        padding-bottom: .5rem;
      }
      .title {
        text-align: left;
        font-size: 1.8rem;
        line-height: 2.4rem;
        padding-bottom: 2rem;
      }
      .desc {
        letter-spacing: 2px;
        span {
          white-space: break-spaces !important;
        }
      }
    }
    .go-back-btn {
      width: 100%;
      margin-bottom: 0;
    }
  }
  .banner-2501 {
    width: 100%;
    // height: 650px;
    position: relative;
    .tx-wrap {
      position: absolute;
      bottom: 10%;
      left: 13.8%;
      z-index: 1;
    }
    .tx-box {
      .tx1 {
        font-size: 32px;
        line-height: 50px;
        font-weight: 500;
        color: var(--unnamed-color-ffffff);
      }
      .tx2,
      .tx3 {
        padding-top: 15px;
        font-size: 16px;
        line-height: 24px;
        color: var(--unnamed-color-ffffff);
      }
    }
    .add-cart-btn {
      margin-top: 36px;
      cursor: pointer;
      width: 125px;
      height: 40px;
      background: var(--unnamed-color-ffffff);
      border: 1px solid var(--unnamed-color-ffffff);
      font-size: 13px;
      line-height: 20px;
      color: var(--unnamed-color-000000);
    }
    @media (max-width:992px) {
      .tx-wrap {

      }
      .tx-box {
        .tx1 {
          font-size: 22px;
          line-height: 25px;
          font-weight: 500;
          color: var(--unnamed-color-ffffff);
        }
        .tx2,
        .tx3 {
          padding-top: 5px;
          font-size: 15px;
          line-height: 15px;
          color: var(--unnamed-color-ffffff);
        }
      }
      .add-cart-btn {
        margin-top: 20px;
        width: 100px;
        height: 30px;
      }
    }
  }
}
</style>
